var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import styled from 'styled-components';
import { get, Box, Icon, Link, Space, Button, TextBody, RadioGroup, RadioButton, } from '@ally/metronome-ui';
import { muiTruthmark } from '@ally/metronome-icons';
import { AriaLive } from '@ally/use-aria-live';
import { CallUs, InaccessibleModal } from './InaccessibleModal';
import { LoginHeading } from '../../../Layout/Layout';
import { logRocketTrack, maskBy, useLogRocketTracking, } from '../../../../../Utils';
// channelIndex is a sequential index, but its only distinct for the given targetIdentifier (sms | email)
var getDeliveryOptionId = function (_a) {
    var _channel = _a._channel, _channelIndex = _a._channelIndex;
    return "".concat(_channel, "-").concat(_channelIndex);
};
var maskTarget = function (target, getOptionType) {
    var description = target._description, channel = target._channel;
    var type = getOptionType(channel);
    return maskBy[type](description);
};
var DeliveryMethodsOptions = function (_a) {
    var targets = _a.targets, onOptionSelectionChange = _a.onOptionSelectionChange, getOptionType = _a.getOptionType;
    return (React.createElement(RadioGroup, { legendText: "Select Device", isLegendHidden: true, name: "mfa-options", onChange: onOptionSelectionChange, defaultValue: getDeliveryOptionId(targets[0]) }, targets.map(function (target) {
        var id = getDeliveryOptionId(target);
        var maskedTarget = maskTarget(target, getOptionType);
        return React.createElement(RadioButton, { key: id, label: maskedTarget, value: id });
    })));
};
var TextOrVoiceSelection = function (_a) {
    var onMethodSelectionChange = _a.onMethodSelectionChange;
    return (React.createElement(Space, { mb: "md" },
        React.createElement(TextBody, { tag: "p", size: "sm", weight: "bold" }, "How would you like to receive the security code?"),
        React.createElement(RadioGroup, { legendText: "Select Method", isLegendHidden: true, name: "mfa-phone-options", onChange: onMethodSelectionChange, defaultValue: "text message" },
            React.createElement(RadioButton, { key: "text message", label: "Text", value: "text message" }),
            React.createElement(RadioButton, { key: "voice", label: "Phone call", value: "voice" }))));
};
var InsightAllyContainer = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  border: 1px solid ", ";\n  background: ", ";\n  padding: 0px 2px;\n  font-size: 16px;\n  border-radius: 3px;\n  box-shadow: 0 1px ", ";\n  font-weight: 700;\n  height: 24px;\n  width: 23px;\n\n  ::after {\n    border-right: 8px solid transparent;\n    border-top: 8px solid #ddd;\n    content: '';\n    position: absolute;\n  }\n\n  ::after {\n    top: 10px;\n    border-color: white transparent transparent transparent;\n    z-index: 10;\n    left: 20px;\n  }\n"], ["\n  position: relative;\n  border: 1px solid ", ";\n  background: ", ";\n  padding: 0px 2px;\n  font-size: 16px;\n  border-radius: 3px;\n  box-shadow: 0 1px ", ";\n  font-weight: 700;\n  height: 24px;\n  width: 23px;\n\n  ::after {\n    border-right: 8px solid transparent;\n    border-top: 8px solid #ddd;\n    content: '';\n    position: absolute;\n  }\n\n  ::after {\n    top: 10px;\n    border-color: white transparent transparent transparent;\n    z-index: 10;\n    left: 20px;\n  }\n"])), get.colors('slate-1'), get.colors('white'), get.colors('slate-3'));
var AllyIcon = function () { return (React.createElement(InsightAllyContainer, null,
    React.createElement(Icon, { icon: muiTruthmark, fill: "plum", size: "md" }))); };
var InaccessibleInline = function (_a) {
    var setShowInlineNumbers = _a.setShowInlineNumbers;
    return (React.createElement(Button, { variant: "link", text: "Can't access this option?", onClick: function () { return setShowInlineNumbers(true); } }));
};
export var SendCodeContent = function (_a) {
    var status = _a.status, targets = _a.targets, hostServices = _a.hostServices, isInPortal = _a.isInPortal, _b = _a.isWebWrapped, isWebWrapped = _b === void 0 ? false : _b, logger = _a.logger, onComplete = _a.onComplete, getOptionType = _a.getOptionType, suppressionStatus = _a.suppressionStatus, variation = _a.variation;
    useLogRocketTracking(logger, 'login-transmit-send-code-load');
    React.useEffect(function () {
        hostServices === null || hostServices === void 0 ? void 0 : hostServices.analytics.trackPageView({
            eventType: 'pageview',
            pageName: 'AOS:Login:Challenge',
        });
    }, []);
    // We don't show voice options since they are just duplicates of SMS options
    var displayTargets = targets
        .filter(function (_a) {
        var _channel = _a._channel;
        var type = getOptionType(_channel);
        return !(type === 'voice');
    })
        .sort(function (_a, _b) {
        var channel1 = _a._channel;
        var channel2 = _b._channel;
        return channel1 - channel2;
    });
    var voiceTargets = targets.filter(function (_a) {
        var _channel = _a._channel;
        var type = getOptionType(_channel);
        return type === 'voice';
    });
    var _c = __read(React.useState(getOptionType(displayTargets[0]._channel)), 2), selectedType = _c[0], setSelectedType = _c[1];
    var _d = __read(React.useState(displayTargets[0]), 2), selectedTarget = _d[0], setSelectedTarget = _d[1];
    var _e = __read(React.useState(false), 2), showInlineNumbers = _e[0], setShowInlineNumbers = _e[1];
    var hasSingleDisplayOption = displayTargets.length === 1;
    var sendCode = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    logRocketTrack('login-transmit-send-code-submit');
                    return [4 /*yield*/, onComplete(selectedTarget)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onOptionSelectionChange = function (id) {
        var optionalTarget = displayTargets.find(function (target) { return id === getDeliveryOptionId(target); });
        if (optionalTarget) {
            var type = getOptionType(optionalTarget._channel);
            // if selectedType is voice and optionalTarget is type sms, find voice target equivalent to set
            var shouldSetVoiceTarget = selectedType === 'voice' && type === 'text message';
            var target = shouldSetVoiceTarget
                ? voiceTargets.find(function (voiceTarget) {
                    return optionalTarget._description === voiceTarget._description;
                })
                : optionalTarget;
            if (target)
                setSelectedTarget(target);
            if (!shouldSetVoiceTarget)
                setSelectedType(type);
        }
    };
    var onMethodSelectionChange = function (method) {
        if (method !== selectedType) {
            setSelectedType(method);
        }
        var targetsWithSelectedType = method === 'voice' ? voiceTargets : displayTargets;
        var target = targetsWithSelectedType.find(function (phoneTarget) { return phoneTarget._description === selectedTarget._description; });
        if (target)
            setSelectedTarget(target);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(LoginHeading, { title: "Confirm it's you.", isInPortal: isInPortal }),
        suppressionStatus === 'NoEmail' && (React.createElement(Box, { display: "flex", alignItems: "flex-start", justifyContent: "left", mb: "md" },
            React.createElement(AllyIcon, null),
            React.createElement(Space, { ml: "sm" },
                React.createElement(TextBody, { size: "sm", tag: "p" },
                    "Some options aren't available right now. If you can't receive your code by text message or voice call, call us at",
                    ' ',
                    React.createElement(Link, { text: "1-877-247-2559.", to: "tel:18772472559" }))))),
        React.createElement(Space, { mb: "md" },
            React.createElement(TextBody, { size: "sm", tag: "p" },
                "We want to know it's really you \u2014 we ask for a security code when we need to double-check. To review or update your security code delivery options, log in and choose",
                ' ',
                React.createElement(TextBody, { size: "sm", tag: "span", weight: "bold" }, "Profile and Settings"),
                ". If you need another option,",
                ' ',
                isInPortal ? ('give us a call') : (React.createElement(InaccessibleModal, { hasSingleDisplayOption: hasSingleDisplayOption, isWebWrapped: isWebWrapped, variation: variation })),
                "."),
            hasSingleDisplayOption ? (React.createElement(TextBody, { size: "sm", tag: "p" },
                "We'll send a security code to",
                ' ',
                maskTarget(selectedTarget, getOptionType))) : (React.createElement(TextBody, { size: "sm", tag: "p", weight: "bold" }, "We'll send a code to your number of choice."))),
        status === 'Error' && (React.createElement(AriaLive, null,
            React.createElement(TextBody, { size: "sm", tag: "p" }, "Please tell us where you want your security code sent."))),
        React.createElement("form", { onSubmit: sendCode, method: "post" },
            !hasSingleDisplayOption && (React.createElement(DeliveryMethodsOptions, { targets: displayTargets, getOptionType: getOptionType, onOptionSelectionChange: onOptionSelectionChange })),
            !(selectedType === 'email') && (React.createElement(TextOrVoiceSelection, { onMethodSelectionChange: onMethodSelectionChange })),
            React.createElement(Box, { display: "flex", flexDirection: ['column', 'column', 'row', 'row'], alignItems: "center", my: "sm" },
                React.createElement(Space, { mr: [0, 0, 'sm', 'sm'], mb: ['sm', 'sm', 'none', 'none'] },
                    React.createElement(Button, { withAllyTM: "sendSecurityCode", text: "Send Security Code", type: "submit", variant: "primary", loading: status === 'Loading' })),
                isInPortal && (React.createElement(InaccessibleInline, { setShowInlineNumbers: setShowInlineNumbers }))),
            showInlineNumbers && (React.createElement(Box, null,
                React.createElement(Space, { mb: "xs" },
                    React.createElement(CallUs, { focusOnMount: true })))))));
};
export var MFASuppressionNoOptions = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(LoginHeading, { title: "Additional Verification Needed" }),
        React.createElement(Box, { display: "flex", alignItems: "flex-start", justifyContent: "left" },
            React.createElement(AllyIcon, null),
            React.createElement(Space, { ml: "sm" },
                React.createElement(Box, null,
                    React.createElement(Space, { mb: "sm" },
                        React.createElement(TextBody, { size: "sm", tag: "p" },
                            "We can't currently email your code, so call us at",
                            ' ',
                            React.createElement(Link, { text: "1-877-247-2559", to: "tel:18772472559" }),
                            " for help."),
                        React.createElement(TextBody, { size: "sm", tag: "p" }, "Next time you log in, consider adding your phone number to your profile so we can send your code by text message.")))))));
};
var templateObject_1;
//# sourceMappingURL=SendCode.js.map